import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import '../HistoryPanel/HistoryPanel.scss';
import { ValidationType, ValidationTypeName } from '../../../Enums';

class ValidationErrorPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validationErrors: props.validationErrorsResponse,
            statusValidationErrors: props.statusValidationErrorsResponse,
        };
    }

    getErrorText = (validationError) => {
        const { t } = this.props;
        let errorMsg = "";

        switch (validationError.validationType) {
            case ValidationType.ScheduleRules:
                if (validationError.validationSubType) {
                    switch (validationError.validationSubType[0]) {
                        case 1:
                            errorMsg = t(`validationError.${ValidationTypeName[validationError.validationType]}.ValidateMaxHoursPerDay`);
                            break;
                        case 2:
                            errorMsg = t(`validationError.${ValidationTypeName[validationError.validationType]}.ValidateMaxShiftsPerDay`);
                            break;
                        default:
                            break;
                    }
                }
                break;
            case ValidationType.AllowedTimeBeforeShift:
            case ValidationType.ShiftMayOverlap:
            case ValidationType.EmployeNotOnProbation:
            case ValidationType.SkillsAndCertifs:
            case ValidationType.JobTransferSetValidation:
            case ValidationType.SameDuration:
            case ValidationType.SwapPeriod:
            case ValidationType.RestBetweenShifts:
            case ValidationType.EmployeeEligibility:
            case ValidationType.EmployeeEligibilityRelativeToShift:
            case ValidationType.MultipleShiftOnSameDay:
            case ValidationType.MaxHoursInRollingPeriod:
            case ValidationType.PaycodeOverlap:
            case ValidationType.EmployeeRestriction:
            case ValidationType.MaxBiWeeklyHours:
                errorMsg = t(`validationError.${ValidationTypeName[validationError.validationType]}`);
                break;
            default:
                break;
        }

        return errorMsg;
    }

    getStatusErrorText = (statusValidationError) => {
        const { t } = this.props;

        switch (statusValidationError.statusValidationType) {
            case 1://Auto-retracted
                return t("validationError.InvalidStatus.AutoRetracted");
            case 2: //already submitted by another EE
                return t("validationError.InvalidStatus.AlreadyTaken");
            default: return '';
        }
    }

    renderErrorList = () => {
        const { validationErrors } = this.state;

        return validationErrors.map((item, index) => {
            return (
                <div style={{ cursor: 'default' }} key={'validationErrors' + index} className="history-item-container">
                    <div className="history-log-first">
                        <span> {this.getErrorText(item)} </span>
                    </div>
                </div>
            )
        })
    }

    renderStatusErrorList = () => {
        const { statusValidationErrors } = this.state;

        return statusValidationErrors.map((item, index) => {
            return (
                <div style={{ cursor: 'default' }} key={'validationErrors' + index} className="history-item-container">
                    <div className="history-log-first">
                        <span> {this.getStatusErrorText(item)} </span>
                    </div>
                </div>
            )
        })
    }

    render() {
        return (
            <>
                <div style={{ marginTop: '15px' }}></div>
                {this.renderErrorList()}
                {this.renderStatusErrorList()}
            </>
        );
    }
}
export default withTranslation('employmentBillboard')(ValidationErrorPanel);
